/**
 * @generated SignedSource<<004bdd6202bad439a083146bdadc657d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternIntegrationsCardCheckMetaMutation$variables = {
  brandId: string;
};
export type InternIntegrationsCardCheckMetaMutation$data = {
  readonly checkBrandMetaConnection: {
    readonly facebookConfig: {
      readonly id: string;
      readonly needsReauth: boolean;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"InternIntegrationsCard_brand">;
  };
};
export type InternIntegrationsCardCheckMetaMutation = {
  response: InternIntegrationsCardCheckMetaMutation$data;
  variables: InternIntegrationsCardCheckMetaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "brandId",
    "variableName": "brandId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLFacebookClientConfig",
  "kind": "LinkedField",
  "name": "facebookConfig",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "needsReauth",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternIntegrationsCardCheckMetaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "checkBrandMetaConnection",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InternIntegrationsCard_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternIntegrationsCardCheckMetaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "checkBrandMetaConnection",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a42092feb9a38765225d5bd15b009718",
    "id": null,
    "metadata": {},
    "name": "InternIntegrationsCardCheckMetaMutation",
    "operationKind": "mutation",
    "text": "mutation InternIntegrationsCardCheckMetaMutation(\n  $brandId: ID!\n) {\n  checkBrandMetaConnection(brandId: $brandId) {\n    facebookConfig {\n      id\n      needsReauth\n    }\n    ...InternIntegrationsCard_brand\n    id\n  }\n}\n\nfragment InternIntegrationsCard_brand on BrandType {\n  id\n  facebookConfig {\n    id\n    needsReauth\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f044e0e2db78dc795f3c3976b5d8b9a";

export default node;
